import { validateHtzService } from '../services/validateHtzService';
import { validateFinRepoService } from '../services/validateFinRepoService';
import { CalculateOpexValues } from '../components/CalculateOpexValues';
import { postRequest } from '../../../shared/utils';

export const FinRepoUploadLogic = async (props) => {
  const { uploadRow, reqData, t, featureName, allRows, tableDetails, userDetails } = props;
  type ResultType = {
    data: { htz: string; message: string; rowNo: number }[];
    errors: { htz: string; message: string; rowNo: number; isError: boolean }[];
    success: boolean;
  };
  const resultSet: ResultType = {
    data: [],
    errors: [],
    success: true,
  };
  for (const [index, item] of uploadRow.entries()) {
    const { htz } = item;
    try {
      if (htz) {
        const isHtz = await validateHtzService(htz, tableDetails.id);
        if (isHtz.npi_npi.length) {
          const { npi_npi: npi } = isHtz;
          const npiId = npi[0].npi_id;
          await validateFinRepo({
            npiId,
            item,
            resultSet,
            t,
            reqData,
            index,
            featureName,
            allRows,
            tableDetails,
            userDetails,
          });
        } else {
          resultSet.errors.push({
            htz: item.htz,
            message: `${t('htz_not_found_npiboard')}`,
            rowNo: index,
            isError: true,
          });
        }
      } else {
        resultSet.errors.push({
          htz: item.htz,
          message: `${t('htz_not_found')} ${index + 2}`,
          rowNo: index,
          isError: true,
        });
      }
    } catch (error) {
      resultSet.success = false;
      resultSet.errors.push({
        htz: item.htz,
        message: t('error.record_failed_following', { htz: item.htz, msg: error.message }),
        rowNo: index,
        isError: true,
      });
    }
  }
  return resultSet;
};

const validateFinRepo = async (props) => {
  const {
    npiId,
    item,
    resultSet,
    t,
    reqData,
    index,
    featureName,
    allRows,
    tableDetails,
    userDetails,
  } = props;
  const finRepo = await validateFinRepoService(npiId, tableDetails.id);
  if (finRepo.npi_tblfinancerepository.length) {
    const { npi_tblfinancerepository: npiTblfinancerepository } = finRepo;
    const finRepoVal = npiTblfinancerepository[0].npi_id;
    if (!finRepoVal) {
      resultSet.data.push({
        htz: item.htz,
        message: `${item.htz} ${t('htz_not_found_finrepo')}`,
      });
    } else {
      if (featureName === 'upload_costing_opex') {
        await CostingOpexLogic({
          reqData,
          index,
          finRepoVal,
          resultSet,
          item,
          t,
          allRows,
          tableDetails,
          userDetails,
        });
      } else {
        await CostingOfferLogic({
          reqData,
          finRepoVal,
          resultSet,
          item,
          t,
          index,
          tableDetails,
          userDetails,
        });
      }
    }
  } else {
    resultSet.errors.push({
      htz: item.htz,
      message: `${item.htz} ${t('htz_not_found_finrepo')}`,
      rowNo: index,
    });
  }
};

const CostingOpexLogic = async ({
  reqData,
  index,
  finRepoVal,
  resultSet,
  item,
  t,
  allRows,
  tableDetails,
  userDetails,
}) => {
  const { npi, tblfinancerepository, rowData } = reqData[index];
  tblfinancerepository.nrp_o_category =
    typeof tblfinancerepository.nrp_o_category === 'string'
      ? tblfinancerepository.nrp_o_category
      : tblfinancerepository.nrp_o_category.toString();
  const cal = await calculateRateService(item, allRows);
  tblfinancerepository.nrp_o_buy_ipa_val = cal.nrp_o_buy_ipa_val;
  tblfinancerepository.nrp_o_total_val = cal.nrp_o_total_val;
  tblfinancerepository.nrc_o_total_val = cal.nrc_o_total_val;
  tblfinancerepository.nrp_o_prog_man_val = cal.nrp_o_prog_man_val;
  tblfinancerepository.nrc_o_prog_man_val = cal.nrc_o_prog_man_val;
  tblfinancerepository.nrp_o_cat_total = cal.nrp_o_cat_total ? cal.nrp_o_cat_total : null;
  tblfinancerepository.nrp_o_cat_total_w_fee = cal.nrp_o_cat_total_w_fee
    ? cal.nrp_o_cat_total_w_fee
    : null;
  tblfinancerepository.nrp_o_cat_total = cal.nrp_o_cat_total ? cal.nrp_o_cat_total : null;
  tblfinancerepository.nrp_o_cat_total_w_fee = cal.nrp_o_cat_total_w_fee
    ? cal.nrp_o_cat_total_w_fee
    : null;
  npi.nrc_value = rowData.nrc_o_total_val ? rowData.nrc_o_total_val : null;
  npi.nrp_value = rowData.nrp_o_total_val ? rowData.nrp_o_total_val : null;
  npi.nrc_cur = 'EUR';
  npi.nrp_cur = rowData.nrp_o_currency;
  if (npi.rp_value) {
    npi.rp_lastmodified = new Date().toISOString().substring(0, 19);
  }
  if (npi.target_cop_value) {
    npi.target_cop_lastmodified = new Date().toISOString().substring(0, 19);
  }
  const schemaName = tableDetails.mbdDataGrid.schemaName;
  const screenGridId = tableDetails.id;
  const where = {};
  where['npi_id'] = { _eq: finRepoVal };
  const finRepoUpdateObjects = [
    {
      where,
      _set: {
        ...tblfinancerepository,
        updated_by: userDetails.userId,
        update_date: new Date().toISOString().substring(0, 19),
      },
    },
  ];
  const financePayload = {
    pkey: 'id',
    schema: schemaName,
    table: 'tblfinancerepository',
    updateObjects: finRepoUpdateObjects,
  };
  const npiUpdateObjects = [
    {
      where,
      _set: {
        ...npi,
        updated_by: userDetails.userId,
        update_date: new Date().toISOString().substring(0, 19),
      },
    },
  ];
  const npiPayload = {
    pkey: 'npi_id',
    schema: schemaName,
    table: 'npi',
    updateObjects: npiUpdateObjects,
  };

  const result = await postRequest('/api/upload', {
    screenGridId,
    tables: [financePayload, npiPayload],
    uploadType: 'upload_costing_opex',
  });
  if (result.errors) {
    resultSet.errors.push({
      htz: item.htz,
      message: `The ${item.htz} could not be updated due to the following error: ${result.errors[0].message}`,
      rowNo: index,
    });
    resultSet.success = false;
  } else {
    resultSet.data.push({
      htz: item.htz,
      message: `${t('updated_successfully')}`,
      rowNo: index,
    });
  }
};

const CostingOfferLogic = async ({
  reqData,
  finRepoVal,
  resultSet,
  item,
  t,
  index,
  tableDetails,
  userDetails,
}) => {
  const { rowData } = reqData[index];
  const tblfinancerepository = {
    nrp_o_s_com_offer_num: rowData.nrp_o_s_com_offer_num,
    nrp_o_po_for_com_offer: rowData.nrp_o_po_for_com_offer,
    last_update: new Date().toISOString().substring(0, 19),
  };
  const schemaName = tableDetails.mbdDataGrid.schemaName;
  const screenGridId = tableDetails.id;
  const where = {};
  where['npi_id'] = { _eq: finRepoVal };
  const finRepoUpdateObjects = [
    {
      where,
      _set: {
        ...tblfinancerepository,
        updated_by: userDetails.userId,
        update_date: new Date().toISOString().substring(0, 19),
      },
    },
  ];
  const financePayload = {
    pkey: 'id',
    schema: schemaName,
    table: 'tblfinancerepository',
    updateObjects: finRepoUpdateObjects,
  };

  const result = await postRequest('/api/upload', {
    screenGridId,
    tables: [financePayload],
    uploadType: 'upload_offer_opex',
  });
  if (result.errors) {
    resultSet.errors.push({
      htz: item.htz,
      message: `Could not be updated due to the following error: ${result.errors[0].message}`,
      rowNo: index,
    });
    resultSet.success = false;
  } else {
    resultSet.data.push({
      htz: item.htz,
      message: `${t('updated_successfully')}`,
      rowNo: index,
    });
  }
};

function calculateRateService(rowData, allRows) {
  const isAvail = allRows.filter((row) => row.npi_htz == rowData.htz);
  const row = {
    ...rowData,
    prog_mgt_fee: isAvail[0]?.prog_mgt_fee,
    exchange_rate: isAvail[0]?.exchange_rate,
    nrp_c_value: isAvail[0]?.nrp_c_value,
  };
  const result = CalculateOpexValues({ row });
  return { ...rowData, ...result };
}
